export const pkg = {
  name: 'isomorphic-git',
  version: '1.25.10',
  agent: 'git/isomorphic-git@1.25.10',
}
